import { FormProvider } from 'react-hook-form';
import { cx } from '@emotion/css';
import { Spinner } from '@phoenix/design-system/frontend/ui/spinner/spinner';

export const HookFormBaseForm = ({ children, className, methods, onSubmit, isLoading = false, ...restProps }: any) => {
  return (
    <FormProvider {...methods}>
      <form
        onSubmit={onSubmit}
        {...restProps}
        className={cx('relative', { submitted: methods.formState.isSubmitted }, className)}
        noValidate
      >
        {isLoading && (
          <div className="absolute inset-0 z-10 flex flex-col items-center justify-center bg-primary-white/75">
            <Spinner data-testid="hookFormLoadingSpinner" />
          </div>
        )}
        {children}
      </form>
    </FormProvider>
  );
};
